import { Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import React from "react";
import { FormattedMessage } from "react-intl";

export const Clear: React.VFC = () => {
  return (
    <div className="snackbar-wrapper">
      <Snackbar type={SNACKBAR_TYPES.SUCCESS} icon>
        <FormattedMessage id="onfido.status.poa.clear" />
      </Snackbar>
    </div>
  );
};
